import * as React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import { createPasswordSchema } from "../../../schemas/changePasswordSchema";
import { changePassword } from "../../../services/apiAuth";
import {
  arePasswordRequirementsMet,
  getAuthErrorMessage,
} from "../utils/authUtils";

export function useChangePasswordForm({ authToken, onSuccess }) {
  const [apiError, setApiError] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const methods = useForm({
    defaultValues: {},
    resolver: yupResolver(createPasswordSchema),
  });
  const password = methods.watch("new_password") || "";

  const submit = React.useCallback(
    (data) => {
      setApiError("");
      setLoading(true);

      changePassword(data, authToken)
        .then(() => {
          onSuccess();
        })
        .catch((error) => {
          setApiError(getAuthErrorMessage(error));
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [authToken, onSuccess]
  );

  return {
    methods,
    apiError,
    loading,
    allRequirementsMet: arePasswordRequirementsMet(password),
    submit,
  };
}
